import { LayoutAdminCafe, LayoutUserCafe } from "../../../layout/layout_cafe";
import { useSelector } from "react-redux";
import { State } from "../../../reducer";
import MenuDessertList from "./menu.dessert.list";

const MenuDessert: React.FC = () => {
  const user = useSelector((state: State) => state.user);
  const Layout = user?.role === "admin" || user?.role === "dev" ? LayoutAdminCafe : LayoutUserCafe;
  return (
    <Layout>
      <MenuDessertList />
    </Layout>
  );
};

export default MenuDessert;
